import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import { rel } from '../../../../../../../utils/rel';

class TuanRecommendL extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    render() {
        const { content } = this.props;

        if (content.length === 0) return <div />;

        return (
            <div className={styles.tuangou}>
                <div className={styles.tuangou_b}>
                    <ul id={styles.tuangou_lst}>
                        <li className={styles.longpic}>
                            <a href={content[0].url} target="_blank" rel={rel}>
                                <div className={styles.tit}>{content[0].title}</div>
                                <img src={content[0].img} />
                            </a>
                        </li>
                    </ul>
                </div>
                <div className={styles.tuangou_page} id="tuangou_page">
                    <ul>
                        <li className={styles.on}>1</li>
                    </ul>
                </div>
            </div>
        );
    }
}

export default errorBoundary(TuanRecommendL);
